import React from "react";
import PropTypes from "prop-types";
import { compose } from "redux";
import Image from "@redbubble/design-system/react/Image";
import Modal, { ModalBody } from "@redbubble/design-system/react/Modal";
import Box from "@redbubble/design-system/react/Box";
import { withAnalytics } from "@redbubble/boom-analytics";
import LoginSignup from "./";
import styles from "./styles.scss";
import { loginFormMessages as messages } from "./messages";
import signUpImage from "./sign_up_image.svg";
import { intlPropType } from "../../lib/propTypes";

const LoginSignupModal = (props) => {
  const { analyticsLabel, header, intl, isOpen, onCloseRequested } = props;

  const LoginSignupWithActions = compose(withAnalytics)(LoginSignup);

  let { onCompleted } = props;
  if (!onCompleted) {
    onCompleted = () => {
      window.location.reload();
    };
  }

  return (
    <Modal
      accessibleTitle={intl.formatMessage(messages.title)}
      open={isOpen}
      onCloseRequested={onCloseRequested}
      getApplicationNode={() => document.getElementById("app")}
      allowClicksOutsideWhenActive
    >
      <ModalBody>
        <Box className={styles.modalBody} id="LoginSignupModal">
          {header || (
            <Image src={signUpImage} alt="" className={styles.signUpImage} />
          )}
          <LoginSignupWithActions analyticsLabel={analyticsLabel} intl={intl} />
        </Box>
      </ModalBody>
    </Modal>
  );
};

LoginSignupModal.displayName = "LoginSignupModal";

LoginSignupModal.propTypes = {
  isOpen: PropTypes.bool,
  onCloseRequested: PropTypes.func.isRequired,
  userInfo: PropTypes.shape({
    locale: PropTypes.string,
    currency: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    showMatureContent: PropTypes.bool,
    isEligibleForAutoSubscribe: PropTypes.bool,
  }),
  intl: intlPropType.isRequired,
  analyticsLabel: PropTypes.string.isRequired,
  onCompleted: PropTypes.func,
  header: PropTypes.node,
};

LoginSignupModal.defaultProps = {
  isOpen: false,
  userInfo: null,
  onCompleted: null,
  header: null,
};

export default LoginSignupModal;
